import { useCallback } from "react";
import { AssembleTypography } from "src/components/AssembleTypography";
import { StyledBlockButton } from "../StyledBlockButton/StyledBlockButton";

const HEADER_2 = "header-two";

export type H2BlockProps = {
  editorState: Draft.EditorState;
  onClick: (headline: string) => void;
};

export const H2Block = (props: H2BlockProps): JSX.Element => {
  const { editorState, onClick } = props;

  const startKey = editorState.getSelection().getStartKey();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(startKey)
    .getType();
  const active = blockType === HEADER_2;

  const onClickHeadline = useCallback(() => {
    onClick(HEADER_2);
  }, [onClick]);

  return (
    <StyledBlockButton active={active} onClick={onClickHeadline}>
      <AssembleTypography style={{ fontSize: "22px", fontWeight: "bold" }}>
        H2
      </AssembleTypography>
    </StyledBlockButton>
  );
};
